
import styles from './style.module.css';
import langData from "../../../../lang/data";
import { useSelector } from "react-redux";

const categories = [
    {
        id: 1,
        title: "Խրթխրթան կարտոֆիլ ֆրի",
        time: "15–20 րոպե",
        image: require('./assets/image-1.png'),
        className: "largeVertical",
    },
    {
        id: 2,
        title: "Հավի թևիկներ",
        time: "20–25 րոպե",
        image: require('./assets/image-2.png'),
    },
    {
        id: 3,
        title: "Քաղցր թխվածք",
        time: "15–25 րոպե",
        image: require('./assets/image-3.png'),
    },
    {
        id: 4,
        title: "Նագեթներ, մատիկ ձողիկներ",
        time: "15–25 րոպե",
        image: require('./assets/image-4.png'),
    },
    {
        id: 5,
        title: "Սթեյք կամ ձուկ",
        time: "15–25 րոպե",
        image: require('./assets/image-5.png'),
    },
    {
        id: 6,
        title: "Բանջարեղեն",
        time: "15–25 րոպե",
        image: require('./assets/image-6.png'),
        className: "wide",
    },
];

function ProductPrepared(props) {

    const { currentLanguage } = useSelector(({main}) => main);

    return (
        <div className={styles.container}>
            <h2>{langData.titles.PreparedProduct[currentLanguage]}</h2>
            <span>
                Խրթխրթան նախուտեստներից մինչև լիարժեք ընթրիք. արագ, համեղ և գրեթե առանց յուղի:
            </span>
            <div className={styles.category_grid}>
                {categories.map((item, index) => (
                    <div
                        key={item.id}
                        className={`${styles.card} ${styles[`card${index + 1}`]}`}
                    >
                        <img src={item.image} alt={item.title} />
                        <div className={styles.overlay} />
                        <h3>{item.title}</h3>
                        <div className={styles.badge}>
                            ⏱ {item.time}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ProductPrepared